<template>
  <div :class="{'el-form-item': validateState == 'error', 'is-error': validateState == 'error'}">
    <el-popover
    placement="right"
    trigger="manual"
    :content="validateMessage"
    v-model="visible">
      <slot slot="reference"></slot>
    </el-popover>
  </div>
</template>

<script>
import AsyncValidator from 'async-validator'

export default {
  name: 'inputValidateBox',
  componentName: 'ElFormItem', // 如果收不到el.form.blur, el.form.change,请看源码
  props: {
    prop: String,
    rules: [Object, Array]
  },
  data () {
    return {
      validateDisabled: false,
      validateState: 'success',
      valiateValue: '',
      validateMessage: '',
      visible: false
    }
  },

  mounted () {
    if (this.prop) {
      this.$on('el.form.blur', this.onFieldBlur)
      this.$on('el.form.change', this.onFieldChange)
    }
  },
  beforeDestroy () {
    this.$off('el.form.blur')
    this.$off('el.form.change')
  },

  methods: {
    onFieldBlur (value) {
      this.validate('blur', value)
    },

    onFieldChange (value) {
      if (this.validateDisabled) {
        this.validateDisabled = false
        return
      }
      if (value === '') {
        return
      }
      this.validate('change', value)
    },

    validate (trigger, value, callback) {
      this.validateDisabled = false
      const rules = this.rules
      this.validateState = 'validating'

      const descriptor = {}
      descriptor[this.prop] = rules

      const validator = new AsyncValidator(descriptor)
      const model = {}

      // 校验数字要手动转换一下，不然始终是字符串
      let index = rules.findIndex((item) => {
        return item.type === 'number'
      })
      if (index > -1 && value !== '') {
        // value = this.$commonJs.toNumber(value)
        value *= 1
      }

      model[this.prop] = value
      validator.validate(model, { firstFields: true }, (errors, invalidFields) => {
        this.validateState = !errors ? 'success' : 'error'
        this.validateMessage = errors ? this.$t(errors[0].message) : ''
        this.visible = !!errors
        if (typeof callback === 'function') {
          callback(this.validateMessage, invalidFields)
        }
      })
    }
  },

  components: {
    AsyncValidator
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/inputValidateBox.vue